import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { createLoadByIdReducer, createLoadListReducerWithBegin } from '../../utils/getCrudConfig';
import { CLIENTS_MODULE } from '../../configs/moduleNames';
import { LOAD_CLIENT_LIST, LOAD_CLIENT_TYPE_LIST } from './actions';
import { LOAD_BY_ID } from '../../configs/actionNames';

const initialState = {
  clientList: [],
  clientTypeList: [],
  clientListMeta: [],
  loadingRemoveUser: false,
  loadingClientList: false,
  loadingClientTypeList: false,
  loadingCurrentClient: false,
  currentClient: {},
};

const reducer = handleActions({
  ...createLoadListReducerWithBegin(CLIENTS_MODULE + LOAD_CLIENT_LIST, 'clientList', 'loadingClientList'),
  ...createLoadListReducerWithBegin(CLIENTS_MODULE + LOAD_CLIENT_TYPE_LIST, 'clientTypeList', 'loadingClientTypeList'),
  ...createLoadByIdReducer(CLIENTS_MODULE + LOAD_BY_ID, 'currentClient', 'loadingCurrentClient'),
}, initialState);

export default reducer;

export const getClientData = createSelector(
  [state => state[CLIENTS_MODULE]],
  state => {
    const {
      clientList,
      clientTypeList,
      clientListMeta,
      loadingClientList,
      loadingClientTypeList,
      loadingCurrentClient,
      currentClient,
    } = state;

    return {
      clientList,
      clientTypeList,
      clientListMeta,
      loadingClientList,
      loadingClientTypeList,
      loadingCurrentClient,
      currentClient,
    };
  },
);
